import './_attachments.scss';

export default function Attachments() {}